import { colourSelectors as selector } from "../Selectors/index";
import ColourService from "../../Service/Item-master/itemColour.service";
import { openSnackbar } from "./snackbarActions";

export const getColour = () => {
  return {
    type: selector.GET_COLOUR,
  };
};

export const getColourSuccess = (color) => {
  return {
    type: selector.GET_COLOUR_SUCCESS,
    payload: color,
  };
};

export const fetchColour = () => {
  return async (dispatch) => {
    dispatch(getColour());
    try {
      const res = await ColourService.getAll();
      dispatch(getColourSuccess(res));
    } catch (e) {
      dispatch(openSnackbar(true, "error", e));
    }
  };
};
